import { gql } from "@apollo/client";

export const UPDATE_TREATMENT = gql`
  mutation updateProgramHistory($id: Int!, $data: UpdateProgramHistoryDto!) {
    updateProgramHistory(id: $id, data: $data) {
      id
      start_date
      end_date
      round
      specialistId
    }
  }
`;
